import Vue from "vue";
import Vuex from "vuex";
import {
  PASSPORT_HOST,
  getGameId,
  getJSON,
  APP_ID,
  post,
  getHrefParam,
  getHrefParamObj
} from "../ultile";
export const UPDATE_TIP_MSG = "updateTipsMsg";
export const ENTER_GAME = "enterGame";
export const LOAD_GAME_URL = "loagGameUrl";
export const SHARE_REWARD = "shareRewardAction";
export const RESFRESH_SHARE_STATUS = "resfreh_share_status";
export const RESFRESH_TIPS_STATUS = "refreshTips";
export const SHOW_TIPS_FIRST_TIME = "showTipsFirstTime";
export const GAME_STATUS_NORMAL = 1;
export const GAME_STATUS_MAINTAIN = 0;
const LOAD_GAME_URL_ACTION = "//m.gm99.com/h5/play_games/enterGameUrl";
const SHARE_REWARD_URL = "//m.gm99.com/h5/page/get_share_reward";
const SHARE_REWARD_URL_LINE = "//m.gm99.com/h5/page/get_line_reward";
const enterGameHost = "add_server";
const CHANGE_GAME_URL = "changeGameUrl";
const CHANGE_GAME_INFO = "changeGameInfo";

Vue.use(Vuex);
const GAME_ID = getGameId();

var getShareTipsStatus = function() {
  let res = false;
  try {
    res =
      window.localStorage.getItem(`show${GAME_ID}ShareFistTime`) === "false" ||
      !window.localStorage.getItem(`show${GAME_ID}ShareFistTime`);
  } catch (e) {}
  return res;
};

var setShareTipsStatus = function(status) {
  try {
    window.localStorage.setItem(`show${GAME_ID}ShareFistTime`, status);
  } catch (e) {}
};

export default {
  strict: process.env.NODE_ENV !== "production", //在非生产环境下，使用严格模式
  state: {
    tipMsg: "",
    gameUrl: "",
    shareStatus: false,
    shareTipsStatus: false,
    showShareTipsFistTime: getShareTipsStatus(),
    gameState: 1,
    maintainUrl: ""
  },
  actions: {
    [ENTER_GAME]({}, params) {
      var anilyzeParam = {
        game_server_sid: params.serverId,
        roleName: params.roleName || "",
        roleId: params.roleId || "",
        roleLevel: params.level || ""
      };
      if (window.isFbCanvas) {
        var fb_source = getHrefParam(
          "fb_source",
          window.parent.location.search
        );
        anilyzeParam["fb_source"] = fb_source || "";
      }
      let linkParam = getHrefParamObj();
      getJSON(PASSPORT_HOST + enterGameHost, { ...anilyzeParam, ...linkParam });
    },
    [LOAD_GAME_URL]({ commit }) {
      let linkParam = getHrefParamObj();
      getJSON(LOAD_GAME_URL_ACTION, {
        is_fb: window.isFbCanvas ? 1 : 0,
        ...linkParam
      }).then(res => {
        if (!res.errmsg) {
          commit(CHANGE_GAME_URL, res.data.enterUrl);
          commit(CHANGE_GAME_INFO, res.data);
        }
      });
    },
    [SHARE_REWARD]({}, shareInfo) {
      var url =
        shareInfo.type == "line" ? SHARE_REWARD_URL_LINE : SHARE_REWARD_URL;
      return post(url, {
        achievementId: shareInfo.achievementId,
        appId: APP_ID,
        gameId: getGameId(),
        serverId: shareInfo.serverId,
        fbid: shareInfo.fbid || "",
        loginAccount: shareInfo.name,
        timestamp: new Date().getTime(),
        roleId: shareInfo.roleId,
        roleName: shareInfo.roleName,
        devicePlate: "pc",
        postId: shareInfo.postId || "",
        token: shareInfo.token,
        sign: ""
      });
    }
  },
  mutations: {
    [UPDATE_TIP_MSG](state, status) {
      state.tipMsg = status;
    },
    [CHANGE_GAME_URL](state, url) {
      state.gameUrl = url;
    },
    [RESFRESH_SHARE_STATUS](state, gameInfo) {
      var { serverInfo, roleInfo } = gameInfo;
      if (serverInfo.serverId && roleInfo.roleId && roleInfo.roleName) {
        state.shareStatus = true;
        state.shareTipsStatus = true;
      } else {
        state.shareStatus = false;
        state.shareTipsStatus = false;
      }
    },
    [RESFRESH_TIPS_STATUS](state, status) {
      // state.shareTipsStatus = status;
      if (getShareTipsStatus()) {
        setShareTipsStatus(!status);
        state.showShareTipsFistTime = getShareTipsStatus();
      }
    },
    [CHANGE_GAME_INFO](state, gameInfo) {
      state.gameState = gameInfo.game.STATE;
      if (gameInfo && gameInfo.game) {
        state.maintainUrl = gameInfo.maintenance_pic;
      } else {
        state.maintainUrl = "";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/gamePage/index.js